import { useEffect } from "react";

const SupportWidget = () => {
  useEffect(() => {
    // Prevent duplicate script injection
    if (document.querySelector('script[src*="buymeacoffee.com/1.0.0/widget.prod.min.js"]')) {
      return;
    }

    const script = document.createElement("script");
    script.src = "https://cdnjs.buymeacoffee.com/1.0.0/widget.prod.min.js";
    script.async = true;

    script.setAttribute("data-name", "BMC-Widget");
    script.setAttribute("data-id", "democraticchess");
    script.setAttribute("data-description", "Support us on Buy me a coffee!");
    script.setAttribute("data-message", "Thank you for supporting Democratic Chess!");
    script.setAttribute("data-color", "#FFDD00");
    script.setAttribute("data-position", "Right");
    script.setAttribute("data-x_margin", "18");
    script.setAttribute("data-y_margin", "18");

    document.body.appendChild(script);

    // Clean up on unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default SupportWidget;
